import { ITimeBaseRequest } from '@mg-platform/core/core-data-access'

export class GetRankingsReports {
  static readonly type = '[rankingsReports] Get Rankings Reports'
  constructor(public payload: ITimeBaseRequest) {}
}
